module.exports = __webpack_public_path__ + "img/014e0b7de3ab2f146a5b4c1bd87b7c20.png";